import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {

    @Input() header = '';
    @Input() message = '';
    @Input() confirm = false;
    @Output() closeAlert = new EventEmitter();
    @Output() alertConfirm = new EventEmitter();

    constructor() { }

    ngOnInit() {
        console.log(this.confirm);
        console.log(typeof(this.confirm));
    }

    onClose() {
        this.closeAlert.emit(false);
    }

    onConfirm(confirm: boolean) {
        this.alertConfirm.emit(confirm);
        this.onClose();
    }

}


